/** Cell value for spreadsheet export. `null` means a blank Excel cell (not zero). */
export type ExportCellValue = string | number | null;

/** Excel number format: thousand separators, no decimals. */
export const EXPORT_INTEGER_NUMBER_FORMAT = '#,##0';

/** Light gray header fill (xlsx-js-style ARGB). */
export const EXPORT_HEADER_FILL_COLOR = 'FFF5F5F5';

export const EXPORT_COLUMN = {
  elementName: 'Element name',
  resourceName: 'Resource name',
  /** Mass in kg for materials; energy products still export their kWh value here. */
  massKg: 'Mass (kg)',
  co2eTotal: 'kgCO2e total',
  costTotal: 'SEK total',
  climateData: 'Climate data',
  dataSource: 'Data source',
  sourceId: 'Source ID',
  epdDescription: 'EPD description',
  sbefParent: 'SBEF parent',
  sbefCode: 'SBEF code',
  boverketCategory: 'Boverket category',
} as const;

export type ExportFixedColumn =
  (typeof EXPORT_COLUMN)[keyof typeof EXPORT_COLUMN];

/**
 * Labels for the building-level row appended below the resource rows. B7 water use and
 * the C-phase schablons are calculated for the building as a whole, so they have no
 * element or product row to sit on and would otherwise be missing from the sheet.
 */
export const EXPORT_BUILDING_LEVEL_ELEMENT_LABEL = 'Building level';
export const EXPORT_BUILDING_LEVEL_RESOURCE_LABEL = 'Not tied to a resource';

/**
 * Builds a CO2e stage header, e.g. `kgCO2e A1-A3`.
 */
export const getExportCo2eStageHeader = (lifecycleLabel: string): string =>
  `kgCO2e ${lifecycleLabel}`;

/**
 * Builds a cost stage header, e.g. `SEK A1-A3`.
 */
export const getExportCostStageHeader = (lifecycleLabel: string): string =>
  `SEK ${lifecycleLabel}`;
